import { AlertTriangle, RefreshCw } from "lucide-react";

export function LoadingState({ label = "Reading portfolio signals" }) {
  return (
    <div className="state-card state-loading" role="status">
      <div className="signal-loader" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
      <p>{label}</p>
    </div>
  );
}

export function ErrorState({
  message,
  retry,
}: {
  message: string;
  retry?: () => void;
}) {
  return (
    <div className="state-card state-error" role="alert">
      <AlertTriangle size={24} aria-hidden="true" />
      <div>
        <strong>Portfolio data is temporarily unavailable</strong>
        <p>{message}</p>
      </div>
      {retry && (
        <button className="button button-secondary" onClick={retry}>
          <RefreshCw size={16} aria-hidden="true" />
          Try again
        </button>
      )}
    </div>
  );
}
